import './Loading.css';
import { AiOutlineLoading } from "react-icons/ai";

export default function Loading({ fullHeight, smallLoading = false }) {
  return (
    <section className={fullHeight ? 'Loadin fullHeight' : smallLoading ? 'loadingSmall' : 'Loadin'}>
      <AiOutlineLoading />
    </section>
  )
}